import React, { useState } from 'react';
import axios from 'axios';

function Signup({ onSignupSuccess, onSwitchToLogin }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [message, setMessage] = useState('');

  // Password validation function
  const validatePassword = (password) => {
    const minLength = 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    if (password.length < minLength) {
      return 'Password must be at least 8 characters long.';
    }
    if (!hasUpperCase) {
      return 'Password must contain at least one uppercase letter.';
    }
    if (!hasLowerCase) {
      return 'Password must contain at least one lowercase letter.';
    }
    if (!hasNumbers) {
      return 'Password must contain at least one number.';
    }
    if (!hasSpecialChar) {
      return 'Password must contain at least one special character.';
    }
    return null;
  };
  const handleSignup = async () => {
    // Email validation
    if (!email.endsWith('@casagrand.co.in')) {
      setMessage('Email must be from @casagrand.co.in domain.');
      return;
    }

    // Password validation
    const passwordError = validatePassword(password);
    if (passwordError) {
      setMessage(passwordError);
      return;
    }

    try {
      const response = await axios.post(process.env.REACT_APP_API_URL + '/signup', {
        email,
        password,
        role: 'user',
      });
      setMessage(response.data.message);
      onSignupSuccess();
    } catch (error) {
      setMessage(error.response.data.error || 'Signup failed');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSignup();
    }
  };

  // Get password strength indicator
  const getPasswordStrength = () => {
    if (!password) return { strength: '', color: '' };

    const validationError = validatePassword(password);
    if (!validationError) {
      return { strength: 'Strong', color: '#10b981' };
    }

    const checks = [
      password.length >= 8,
      /[A-Z]/.test(password),
      /[a-z]/.test(password),
      /\d/.test(password),
      /[!@#$%^&*(),.?":{}|<>]/.test(password)
    ];

    const passedChecks = checks.filter(Boolean).length;

    if (passedChecks >= 4) return { strength: 'Good', color: '#f59e0b' };
    if (passedChecks >= 2) return { strength: 'Fair', color: '#ef4444' };
    return { strength: 'Weak', color: '#ef4444' };
  };
  return (
    <div className="auth-form">
      {/* <div className="signup-header">
        <h3 style={{ 
          textAlign: 'center', 
          marginBottom: '1.5rem', 
          color: '#374151', 
          display: 'flex', 
          alignItems: 'center', 
          justifyContent: 'center', 
          gap: '0.5rem',
          fontSize: '1.2rem',
          fontWeight: '600'
        }}>
          📝 Sign Up
        </h3>
      </div> */}

      <div className="form-group">
        <label className="form-label">Email ID</label>
        <input
          type="email"
          className="form-input"
          placeholder="Enter your @casagrand.co.in email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          onKeyPress={handleKeyPress}
        />
      </div>

      <div className="form-group">
        <label className="form-label">Password</label>
        <div className="password-input-container">
          <input
            type={showPassword ? "text" : "password"}
            className="form-input"
            placeholder="Create a strong password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
          />
          <button
            type="button"
            className="password-toggle"
            onClick={() => setShowPassword(!showPassword)}
          >
            {showPassword ? '👁️' : '👁️‍🗨️'}
          </button>
        </div>
        {password && (
          <div style={{
            marginTop: '0.5rem',
            fontSize: '0.85rem',
            color: getPasswordStrength().color,
            fontWeight: '500'
          }}>
            Password Strength: {getPasswordStrength().strength}
          </div>
        )}
        <div style={{
          marginTop: '0.5rem',
          fontSize: '0.8rem',
          color: '#6b7280',
          lineHeight: '1.4'
        }}>
          Password must contain: 8+ characters, uppercase, lowercase, number, and special character
        </div>
      </div>

      <button onClick={handleSignup} className="btn btn-primary w-100P">
        Create Account
      </button>

      <div className="switch-text">
        Already have an account? <button onClick={onSwitchToLogin} className="btn-link">Login</button>
      </div>

      {message && (
        <div className={`message ${message.includes('failed') || message.includes('must be') ? 'error' : 'success'}`} style={{ position: 'relative', marginTop: '1rem' }}>
          {message}
        </div>
      )}
    </div>
  );
}
export default Signup;